import { type SVGProps } from "react";
const IconNavSubmissions = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.5 2.5h-15A1.25 1.25 0 0 0 1.25 3.75v12.5A1.25 1.25 0 0 0 2.5 17.5h15a1.25 1.25 0 0 0 1.25-1.25V3.75A1.25 1.25 0 0 0 17.5 2.5Zm0 1.25v2.083L10 11.458 2.5 5.833V3.75h15ZM2.5 16.25V7.5l7.083 5.208a.625.625 0 0 0 .834 0L17.5 7.5v8.75H2.5Z"
    />
  </svg>
);
export default IconNavSubmissions;
